import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';

export default class AuthenticatedSyfDashboardController extends Controller {
  @tracked benefitYear = null;

  queryParams = ['benefitYear'];
}
